import { BrowserRouter, Route, Routes } from 'react-router-dom';

import MainPage from "./pages/MainPage";
import TrafficInformationPage from './pages/TrafficInformationPage';
import LocalInformationPage from './pages/LocalInformationPage';
import MobileTrafficInformationPage from './pages/MobileTrafficInformationPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import MyPage from './pages/MyPage';
import KrpanoExample from './pages/Krpano';
import LocalKrpano from './pages/LocalKrpano';
import { AreaData } from './Data/AreaData';
import AreaMap from './pages/AreaMap';
import MapExample from './pages/NaverMap';
import KakaoMap from './pages/Kakaomap';
import TmapRouteMap from './TmapRouteMap';
import TMapExample from './pages/\bTMap';


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<MainPage/>}/>
        <Route path='/Load' element={<TrafficInformationPage/>}/>
        <Route path='/MLoad' element={<MobileTrafficInformationPage/>}/>
        <Route path='/Local' element={<LocalInformationPage/>}/>
        <Route path='/LoginPage' element={<LoginPage/>}/>
        <Route path='/SignUpPage' element={<SignUpPage/>}/>
        <Route path='/MyPage' element={<MyPage/>}/>
        <Route path='/KrPano' element={<KrpanoExample/>}/>
        <Route path='/LocalKrPano' element={<LocalKrpano/>}/>
        <Route path='/AreaMap' element={<AreaMap/>}/>
        <Route path='/NaverMap' element={<MapExample/>}/>
        <Route path='/KakaoMap' element={<KakaoMap/>}/>
        <Route path='/TMap' element={<TMapExample/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
